export const StripeACHBankAccountTypes = {
  INDIVIDUAL: "individual",
  COMPANY: "company",
} as const;

export const StripeACHBankAccountTypesWithLabels = {
  [StripeACHBankAccountTypes.INDIVIDUAL]: "Individual",
  [StripeACHBankAccountTypes.COMPANY]: "Company",
} as const;
